var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_vm._v("Value: "+_vm._s(_vm.text || 'Nothing'))]),_c('ImageBarcodeReader',{on:{"decode":_vm.onDecode,"error":_vm.onError}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }